import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./search-error.scss";

export const SearchError = ({error, onChangeStreet}) => cs(
    () => (
        <div className="search-error-4rr">
            {error.type === "existed" ? <>
                <div className="message" xd-qa-type="label" xd-qa-name="Build Street List Duplicate Street Error">
                    Street <b>{error.address}</b> is already in the list below
                </div>
            </> : error.type === "alternateStreets" ? <>
                <div className="message" xd-qa-type="label" xd-qa-name="Build Street List Similar Street Error">
                    Could not find <b>{error.address}</b> in zip code <b>{error.zip}</b>. Select from one of the following similarly
                    named streets or search again.
                </div>
                <table className="alternate-streets" cellSpacing={0} cellPadding={0}>
                    <tbody>
                    {error.streets.map((s, i) => (
                        <tr>
                            <td className="street" key={i} onClick={() => onChangeStreet(s)} xd-qa-type="button" xd-qa-name={"Build Street List "+s}>
                                {s}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </> : error.type === "multipleFound" ? <>
                <div className="message" xd-qa-type="label" xd-qa-name="Build Street List Multiple Street Error">
                    Found multiple street names with "<b>{error.address}</b>" in zip code <b>{error.zip}</b>. Select from one of the following
                    named streets or search again.
                </div>
                <table className="alternate-streets" cellSpacing={0} cellPadding={0}>
                    <tbody>
                    {error.streets.map((s, i) => (
                        <tr>
                            <td className="street" key={i} onClick={() => onChangeStreet(s)} xd-qa-type="button" xd-qa-name={"Build Street List "+s}>
                                {s}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </> : <>
                <div className="message" xd-qa-type="label" xd-qa-name="Build Street List Not Found Error">
                    Could not find <b>{error.address}</b> in zip code <b>{error.zip}</b>
                </div>
            </>}

        </div>
    ),
);